import { render, staticRenderFns } from "./AccWhiteCard.vue?vue&type=template&id=50920179"
import script from "./AccWhiteCard.vue?vue&type=script&lang=js"
export * from "./AccWhiteCard.vue?vue&type=script&lang=js"
import style0 from "./AccWhiteCard.vue?vue&type=style&index=0&id=50920179&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports